import { useFilter } from '@features/table-filter';

import { useGetFormsQuery } from '../api';
import { IFormFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
}

export const useForms = ({ disableUrlFilter = false }: IProps = {}) => {
  const filter = useFilter<IFormFilter>({ disableUrlFilter });
  const { currentFilter } = filter;

  const {
    data: forms,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetFormsQuery(currentFilter.toString());

  return {
    forms,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
